import React from 'react';
import { Col, Row } from 'react-bootstrap';
import _ from 'underscore';

import CyclesList from '../../../../commonComponents/CyclesList/CyclesList';
import SubHeader from '../../../../commonComponents/SubHeader/SubHeader';
import TextLink from '../../../../commonComponents/TextLink/TextLink';
import {
  FIXED_DUTY_STATE,
  VALID_RANKS,
} from '../../../../constants/examConstants';
import { getRatingExam } from '../../../../utilities/getItemsHelper';
import { canPerformAction } from '../../../../utilities/permissionUtils';

const dutyState = [FIXED_DUTY_STATE]; // ['Regular']
const ranks = VALID_RANKS; // ['E5', 'E6']

export default class BibliographyList extends React.Component {
  state = {
    search: '',
    viewArchivedCycles: false,
  };

  getRatesAdmins = () => {
    let { rates } = this.props;
    const {
      rank,
      dutyState,
      rate,
      onListUpdate,
      ratingExamQuestions,
      getRateRatingExamQuestions,
    } = this.props;
    if (this.state.search !== '') {
      const search = this.state.search.toLowerCase();
      rates = rates.filter((r) => {
        if (r.id !== 0) {
          return (
            r.name.toLowerCase().includes(search) ||
            r.shortname.toLowerCase().includes(search)
          );
        }
        return null;
      });
    }
    if (rates.length > 0) {
      if (rates[0].id === 0) {
        rates.shift();
      }
      return rates.map((r, i) => (
        <RateLine
          setIsUndoChecked={this.props.setIsUndoChecked}
          setIsRevertChecked={this.props.setIsRevertChecked}
          setUndoState={this.props.setUndoState}
          setActualState={this.props.setActualState}
          cycle={this.props.cycle}
          key={`${r}_${i}`}
          rate={r}
          rank={rank}
          selectedRate={rate}
          dutyState={dutyState}
          onUpdate={onListUpdate}
          ratingExamQuestions={ratingExamQuestions}
          onRateUpdate={getRateRatingExamQuestions}
        />
      ));
    }
    return <p>No AFSCs</p>;
  };

  selectCycle(cycle) {
    this.props.updateSelectedCycle(cycle);
  }

  sortCycles = (cycles) => {
    const activeCycles = _.filter(cycles, { isActive: true });
    const nonActiveCycles = _.filter(cycles, { isActive: false });

    return activeCycles.concat(nonActiveCycles);
  };

  toggleCycles = () => {
    if (this.state.viewArchivedCycles) {
      this.props.loadCycles();
    } else {
      this.props.loadArchivedCycles();
    }
    this.setState({ viewArchivedCycles: !this.state.viewArchivedCycles });
  };

  getCycles = () => {
    const viewCyclesLinkText = this.state.viewArchivedCycles
      ? 'View Active'
      : 'View Achived';
    return (
      <div>
        <CyclesList
          cycles={this.sortCycles(this.props.cycles)}
          selected={this.props.selectedCycle}
          onCycleClick={(cycle) => this.selectCycle(cycle)}
          showNewCycle={!this.state.viewArchivedCycles}
        />
        <div className="TextLinkAtBottom">
          <hr />
          <TextLink onAction={this.toggleCycles} text={viewCyclesLinkText} />
        </div>
      </div>
    );
  };

  onSearch = (event) => {
    this.setState({ search: event.target.value });
  };

  clearSearchInput = () => {
    this.setState({ search: '' });
  };

  getVisibleOptions = () => {
    const { permissions } = this.props;
    const options = [];
    if (canPerformAction('Bibliographies.AFSCExam', permissions)) {
      options.push('AFSC Exam');
    }
    if (canPerformAction('Bibliographies.Cycles', permissions)) {
      options.push('Cycles');
    }
    return options;
  };

  render() {
    let searchAction;
    let plusAction;
    const canManageCycles = canPerformAction(
      'Bibliographies.Cycles.Manage',
      this.props.permissions,
    );
    const visibleOptions = this.getVisibleOptions();

    if (
      this.props.activeListTab === visibleOptions[0] &&
      this.props.activeListTab === 'AFSC Exam'
    ) {
      searchAction = this.onSearch;
    } else if (canManageCycles && this.props.activeListTab === 'Cycles') {
      plusAction = () => {
        this.props.updateSelectedCycle({
          plusAction: true,
          title: '',
          description: '',
        });
      };
    }
    return (
      <Col
        md={3}
        className="GroupList"
        style={{
          paddingLeft: '0px',
          paddingRight: '0px',
          minWidth: '400px',
        }}
      >
        <SubHeader
          options={visibleOptions}
          onOptionChange={this.props.onUpdateSelectedListTab}
          activeOption={this.props.activeListTab}
          onSearch={searchAction}
          onPlusClick={plusAction}
          searchValue={this.state.search}
          clearSearchInput={this.clearSearchInput}
        />
        <div className="ratesContainer">
          {this.props.activeListTab === 'Cycles' &&
          visibleOptions.includes('Cycles')
            ? this.getCycles()
            : this.props.activeListTab === 'AFSC Exam' &&
                visibleOptions.includes('AFSC Exam')
              ? this.getRatesAdmins()
              : null}
        </div>
      </Col>
    );
  }
}

export class RateLine extends React.Component {
  state = {
    expanded:
      this.props.selectedRate &&
      this.props.rate &&
      this.props.selectedRate.id === this.props.rate.id,
  };

  filterClick = (rank, dutyState) => {
    this.props.onUpdate(this.props.rate, rank, dutyState);
    this.props.setIsUndoChecked(true);
    this.props.setIsRevertChecked(true);
    this.props.setUndoState(null);
    this.props.setActualState(null);
  };

  getRowClass = (currentRank, currentDutyState) => {
    const {
      rate,
      rank,
      dutyState,
      selectedRate,
      ratingExamQuestions = [],
    } = this.props;
    if (
      rate.id === selectedRate.id &&
      rank === currentRank &&
      currentDutyState === dutyState
    ) {
      return 'activeRow';
    }
    const questions = ratingExamQuestions.find(
      (a) =>
        a.rank === currentRank &&
        a.dutyState === currentDutyState &&
        a.rate === rate.id,
    );
    if (questions && questions.linkedRatingExam) {
      const res =
        questions.dutyState === 'Substitute' ||
        questions.dutyState === 'Reserve'
          ? 'linked'
          : '';
      return res;
    }
    return '';
  };

  getQuestions = (rank, dutyState) => {
    const { ratingExamQuestions = [], rate } = this.props;
    const questions = ratingExamQuestions.find(
      (a) => a.rank === rank && a.dutyState === dutyState && a.rate === rate.id,
    );
    if (questions) {
      return (
        <span style={{ float: 'right' }}>
          {questions.dutyState === 'Substitute' &&
          questions.linkedRatingExam ? (
            <i className="fa fa-link bibliography-linked" />
          ) : questions.dutyState === 'Reserve' &&
            questions.linkedRatingExam ? (
            <i className="fa fa-link bibliography-linked" />
          ) : (
            ''
          )}
          <b>{questions.percentage}</b> {questions.questions}
        </span>
      );
    }
    return (
      <span style={{ float: 'right' }}>
        <b>0%</b> 0 of 0
      </span>
    );
  };

  shouldGetRatingExamQuestions = (expanded) => {
    const { ratingExamQuestions = [], rate, onRateUpdate } = this.props;
    const questions = ratingExamQuestions.find((a) => a.rate === rate.id);
    if (!questions && expanded) {
      onRateUpdate(rate, this.props.rank, this.props.dutyState);
    }
  };

  getDisableButton = (rank, dutyState) => {
    const { ratingExamQuestions = [], rate } = this.props;
    const questions = ratingExamQuestions.find(
      (a) => a.rank === rank && a.dutyState === dutyState && a.rate === rate.id,
    );
    let notClick = false;
    if (questions) {
      if (
        (questions.dutyState === 'Substitute' ||
          questions.dutyState === 'Reserve') &&
        questions.linkedRatingExam
      ) {
        notClick = true;
        return notClick;
      }
    }
    return notClick;
  };

  getRow = (currentRank) => {
    const { rate } = this.props;
    return (
      <Row
        className={`${this.getRowClass(currentRank, FIXED_DUTY_STATE)} pointer`}
        onClick={() => this.filterClick(currentRank, FIXED_DUTY_STATE)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.filterClick(currentRank, FIXED_DUTY_STATE);
          }
        }}
      >
        <Col md={4} className="centerText">
          {getRatingExam(rate.shortname, currentRank)}
        </Col>

        <Col md={8}>{this.getQuestions(currentRank, FIXED_DUTY_STATE)}</Col>
      </Row>
    );
  };

  getExpandedContent = () => (
    <div className="expandedContentContainer">
      {VALID_RANKS.map((rank) => this.getRow(rank))}
    </div>
  );

  getExpandedContentOld() {
    return (
      <div style={{ width: '50%', margin: '0 auto', paddingTop: '10px' }}>
        {ranks.map((r) => (
          <Row>
            <Col md={6}>{r}</Col>
            <Col md={6}>
              {dutyState.map((d) => (
                <p>{d}</p>
              ))}
            </Col>
          </Row>
        ))}
      </div>
    );
  }

  renderExpandIcon() {
    return (
      <div className="expandIconContainer">
        <i
          className={
            this.state.expanded
              ? 'fa fa-caret-down marginRight14'
              : 'fa fa-caret-right marginRight18'
          }
          aria-hidden="true"
        />
      </div>
    );
  }

  render() {
    const { rate } = this.props;
    const { expanded } = this.state;
    return (
      <div className="Group">
        <div
          className="GroupRowHover"
          style={{ display: 'flex', alignItems: 'center' }}
          onClick={() => {
            this.shouldGetRatingExamQuestions(!expanded);
            this.setState({ expanded: !expanded });
          }}
        >
          {this.renderExpandIcon()}
          <div className="RateName">
            <span className="rateNameLabel">
              {rate.shortname ? `(${rate.shortname}) ${rate.name}` : rate.name}
            </span>
            <div className="percentage">
              <span>
                <b>{rate.percentage}</b> {rate.questions}
              </span>
            </div>
          </div>
        </div>
        {expanded && this.getExpandedContent()}
      </div>
    );
  }
}
